// Şube yöneticisi panelindeki Stok Sayım sekmesi: liste ve detay aynı sekmede açılır,
// depolar yalnız şubeye bağlı olanlarla sınırlanır, butonlar alt yetkilere göre görünür.
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import StockCountsPage from '../accounting/inventory/stockCount/StockCountsPage';
import StockCountDetailPage from '../accounting/inventory/stockCount/StockCountDetailPage';
import type { InventoryWarehouseDto } from '../accounting/inventory/services/warehouseService';
import { getBranches as getBranchesAdapter } from '../../services/migration/branchDataService';
import { useManagerStockCountPermissions } from './useManagerStockCountPermissions';

interface Props {
  branchId: string;
}

const ManagerStockCountPanel: React.FC<Props> = ({ branchId }) => {
  const perms = useManagerStockCountPermissions(true);
  const [openId, setOpenId] = useState<string | null>(null);
  const [aliases, setAliases] = useState<Set<string>>(() => new Set([branchId]));

  // Depo.BranchesId SQL Id ya da Firebase Id taşıyabilir; ikisi de eşleşmeli.
  useEffect(() => {
    let cancelled = false;
    getBranchesAdapter('')
      .then((list: any[]) => {
        if (cancelled) return;
        const next = new Set<string>([branchId]);
        const b = list.find((x) => x.id === branchId || String(x.sqlId) === branchId);
        if (b) {
          next.add(b.id);
          if (b.sqlId != null) next.add(String(b.sqlId));
        }
        setAliases(next);
      })
      .catch((err) => console.warn('[ManagerStockCountPanel] Şubeler yüklenemedi:', err));
    return () => { cancelled = true; };
  }, [branchId]);

  const warehouseFilter = useMemo(
    () => (w: InventoryWarehouseDto) => !!(w as any).branchesId && aliases.has(String((w as any).branchesId)),
    [aliases],
  );
  const back = useCallback(() => setOpenId(null), []);

  if (!perms.loaded) return <Box sx={{ p: 6, textAlign: 'center' }}><CircularProgress /></Box>;

  return openId
    ? <StockCountDetailPage countId={openId} onBack={back} perms={perms} />
    : <StockCountsPage perms={perms} warehouseFilter={warehouseFilter} onOpenCount={setOpenId} />;
};

export default ManagerStockCountPanel;
